var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _rect3, _rect4, _rect5, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDukan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 504,
    viewBox: "0 0 595 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.847 129.238C454.747 156.176 516.269 192.38 524.948 237.269C533.627 282.159 489.534 335.819 440.661 377.816C391.787 419.812 338.134 450.433 292.533 442.466C246.931 434.499 209.343 387.99 161.534 345.915C113.863 303.82 56.1018 266.245 44.3275 216.843C32.5533 167.441 66.9029 106.297 114.581 79.3658C162.259 52.4347 223.403 59.716 272.08 72.1824C320.757 84.6488 356.968 102.333 405.847 129.238Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.203 61.2703L46.0449 299.928L442.77 377.26L273.203 61.2703Z",
    stroke: "#E5E5E5",
    strokeWidth: 2.84723,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M505.686 322.458H372.428C367.059 322.458 361.909 320.325 358.113 316.528C354.316 312.732 352.184 307.583 352.184 302.214V182.975C352.184 177.606 354.316 172.457 358.113 168.66C361.909 164.864 367.059 162.731 372.428 162.731H505.686C511.055 162.731 516.204 164.864 520.001 168.66C523.797 172.457 525.93 177.606 525.93 182.975V302.233C525.925 307.599 523.79 312.743 519.994 316.535C516.198 320.327 511.051 322.458 505.686 322.458Z",
    fill: "#F79009"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M439.717 190.718C432.202 190.718 426.053 196.867 426.053 204.382V209.848H431.519V204.382C431.519 199.873 435.208 196.184 439.717 196.184C444.227 196.184 447.916 199.873 447.916 204.382V209.848H453.382V204.382C453.382 196.867 447.233 190.718 439.717 190.718Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M456.112 245.376H423.317C420.311 245.376 417.852 242.916 417.852 239.91V215.314C417.852 212.308 420.311 209.848 423.317 209.848H456.112C459.119 209.848 461.578 212.308 461.578 215.314V239.91C461.578 242.916 459.119 245.376 456.112 245.376Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.617 227.612C435.617 228.699 436.049 229.742 436.818 230.511C437.587 231.28 438.629 231.711 439.717 231.711C440.804 231.711 441.846 231.28 442.615 230.511C443.384 229.742 443.816 228.699 443.816 227.612C443.816 226.525 443.384 225.482 442.615 224.713C441.846 223.945 440.804 223.513 439.717 223.513C438.629 223.513 437.587 223.945 436.818 224.713C436.049 225.482 435.617 226.525 435.617 227.612Z",
    fill: "#C76E00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 380.184,
    y: 262.323,
    width: 121.024,
    height: 37.146,
    fill: "#F0EDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 380.184,
    y: 295.075,
    width: 121.024,
    height: 4.39361,
    fill: "#C6C6C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M401.78 275.567L402.627 278.269L395.043 280.327L394.398 278.39L401.78 275.567ZM400.489 284.885L398.19 286.539L393.914 279.964L395.527 278.753L400.489 284.885ZM391.251 286.539L388.952 284.885L393.914 278.753L395.527 279.964L391.251 286.539ZM386.813 278.269L387.661 275.567L395.043 278.39L394.398 280.327L386.813 278.269ZM393.308 271.492H396.132L395.729 279.359H393.712L393.308 271.492ZM425.654 275.567L426.501 278.269L418.917 280.327L418.271 278.39L425.654 275.567ZM424.363 284.885L422.064 286.539L417.787 279.964L419.401 278.753L424.363 284.885ZM415.125 286.539L412.825 284.885L417.787 278.753L419.401 279.964L415.125 286.539ZM410.687 278.269L411.534 275.567L418.917 278.39L418.271 280.327L410.687 278.269ZM417.182 271.492H420.006L419.603 279.359H417.586L417.182 271.492ZM449.528 275.567L450.375 278.269L442.791 280.327L442.145 278.39L449.528 275.567ZM448.237 284.885L445.937 286.539L441.661 279.964L443.275 278.753L448.237 284.885ZM438.999 286.539L436.699 284.885L441.661 278.753L443.275 279.964L438.999 286.539ZM434.561 278.269L435.408 275.567L442.791 278.39L442.145 280.327L434.561 278.269ZM441.056 271.492H443.88L443.477 279.359H441.46L441.056 271.492ZM473.402 275.567L474.249 278.269L466.665 280.327L466.019 278.39L473.402 275.567ZM472.111 284.885L469.811 286.539L465.535 279.964L467.149 278.753L472.111 284.885ZM462.873 286.539L460.573 284.885L465.535 278.753L467.149 279.964L462.873 286.539ZM458.435 278.269L459.282 275.567L466.665 278.39L466.019 280.327L458.435 278.269ZM464.93 271.492H467.754L467.35 279.359H465.333L464.93 271.492Z",
    fill: "#605A5A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 522.18,
    y: 135.731,
    width: 3.58656,
    height: 15.7808,
    fill: "#FDB022"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 553.023,
    y: 162.989,
    width: 3.58656,
    height: 15.7808,
    transform: "rotate(89.5935 553.023 162.989)",
    fill: "#FDB022"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 548.955,
    y: 136.687,
    width: 3.58656,
    height: 24.3736,
    transform: "rotate(44.9209 548.955 136.687)",
    fill: "#FDB022"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.271 243.48C293.903 243.48 293.903 385.567 286.968 398.131C280.033 410.696 173.288 408.789 165.393 398.158C157.497 387.526 154.48 243.48 223.271 243.48Z",
    fill: "#F04438"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.621 219.246C241.85 219.246 259.059 202.037 259.059 180.808C259.059 159.58 241.85 142.371 220.621 142.371C199.393 142.371 182.184 159.58 182.184 180.808C182.184 202.037 199.393 219.246 220.621 219.246Z",
    fill: "#FECDCA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M244.248 166.794C243.686 162.876 241.74 159.898 239.918 160.166C238.096 160.433 237.065 163.823 237.633 167.747C238.201 171.672 240.14 174.65 241.962 174.382C243.784 174.115 244.816 170.725 244.248 166.794Z",
    stroke: "#9F0056",
    strokeWidth: 2.38358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M199.972 132.079C213.248 132.079 224.01 121.316 224.01 108.04C224.01 94.7645 213.248 84.0023 199.972 84.0023C186.696 84.0023 175.934 94.7645 175.934 108.04C175.934 121.316 186.696 132.079 199.972 132.079Z",
    fill: "#F04438"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.887 265.409C237.885 260.844 239.238 256.381 241.773 252.585C244.308 248.789 247.912 245.83 252.129 244.082C256.346 242.335 260.986 241.877 265.463 242.766C269.94 243.656 274.053 245.854 277.281 249.081C280.51 252.308 282.708 256.42 283.599 260.897C284.49 265.374 284.034 270.015 282.287 274.232C280.541 278.45 277.583 282.054 273.787 284.59C269.992 287.127 265.53 288.48 260.965 288.48C254.845 288.48 248.976 286.05 244.648 281.723C240.321 277.397 237.888 271.528 237.887 265.409V265.409Z",
    fill: "#FECDCA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.25 278.528C66.25 268.008 83.2289 268.008 83.2289 257.487C83.2289 246.967 66.25 246.967 66.25 236.447C66.25 225.926 83.2289 225.933 83.2289 215.412C83.2289 204.892 66.25 204.892 66.25 194.372C66.25 183.851 83.2289 183.845 83.2289 173.324C83.2289 162.804 66.25 162.804 66.25 152.284C66.25 141.763 83.2289 141.763 83.2289 131.243C83.2289 120.722 66.25 120.716 66.25 110.196C66.25 99.6752 83.2289 99.6752 83.2289 89.1483",
    stroke: "#FDB022",
    strokeWidth: 3.3566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M475.702 394.768H349.666V404.564H475.702V394.768Z",
    fill: "#F04438"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M484.088 399.666L475.605 394.768V404.564L484.088 399.666Z",
    fill: "#FFE9F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M480.9 397.831V401.508L484.087 399.666L480.9 397.831Z",
    fill: "#CC0071"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.396 406.784C222.592 389.821 229.469 373.619 241.534 361.693C253.599 349.767 269.88 343.08 286.844 343.081C287.373 343.081 287.902 343.081 288.425 343.081",
    stroke: "#FDB022",
    strokeWidth: 3.3566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.265 246.046C218.982 254.225 226.864 265.559 230.803 278.453C234.742 291.346 234.538 305.15 230.221 317.922C225.905 330.694 217.692 341.79 206.738 349.65C195.785 357.51 182.643 361.738 169.161 361.738C166.566 361.738 163.973 361.585 161.396 361.281",
    stroke: "#FDB022",
    strokeWidth: 3.3566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.159 391.83H197.836V437.542H221.998L278.159 391.83Z",
    fill: "#777777"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M221.999 328.485H50.9043V437.542H221.999V328.485Z",
    fill: "#C2C2C2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.45 394.768C142.942 394.768 148.205 389.506 148.205 383.014C148.205 376.522 142.942 371.259 136.45 371.259C129.958 371.259 124.695 376.522 124.695 383.014C124.695 389.506 129.958 394.768 136.45 394.768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDukan);
export default __webpack_public_path__ + "static/media/dukan.e2ad33ab316d3abfd4bab3a76daddb74.svg";
export { ForwardRef as ReactComponent };